<script setup lang="ts">
import { computed } from "vue";
import { useStore } from "vuex";
import { addSizeToDataLayer } from "@/functions/analytics";
import DimensionInput from "@/components/UI/DimensionInput.vue";
import ShapeInputFieldsWrapper from "@/components/UI/ShapeInputFieldsWrapper.vue";
import {Props} from "@/components/ShapeType.vue";

const store = useStore();
const { isCutout, action, prefix } = defineProps<Props>();

const dimensions = computed(() => store.getters.getMeasurements( 'arched-rectangle', isCutout ) );
const dimensionLabel = computed(() => store.getters.dimensionLabel);
const dimensionMaxLabel = computed(() => store.getters.getMaxLabelForDimension);
const isDimensionValid = computed(() => store.getters.isShapeValid( isCutout ) );

const width = computed({
	get: () => dimensions.value.width,
	set: (value: string) => {
		store.dispatch(action, {
			dimension: "width",
			value: value,
		});
	},
});

const height = computed({
	get: () => dimensions.value.height,
	set: (value: string) => {
		store.dispatch(action, {
			dimension: "height",
			value: value,
		});
	},
});
</script>
<template>
	<shape-input-fields-wrapper>
		<dimension-input
			inputRef="arched-rectangle-width"
			:id="`${prefix}measurements-arched-rectangle-width`"
			:name="`${prefix}measurements[dimensions][width]`"
			unit="cm"
			:label="dimensionLabel('width', 'arched-rectangle')"
			:instructions="isCutout ? '' : dimensionMaxLabel('width')"
			:invalid="!isDimensionValid(`${prefix}arched-rectangle-width`)"
			:onBlur="() => addSizeToDataLayer('width', +width, 'arched-rectangle')"
			v-model="width"
		/>

		<dimension-input
			inputRef="arched-rectangle-height"
			:id="`${prefix}measurements-arched-rectangle-height`"
			:name="`${prefix}measurements[dimensions][height]`"
			unit="cm"
			:label="dimensionLabel('height', 'arched-rectangle')"
			:instructions="isCutout ? '' : dimensionMaxLabel('height')"
			:invalid="!isDimensionValid(`${prefix}arched-rectangle-height`)"
			:onBlur="() => addSizeToDataLayer('height', +height, 'arched-rectangle')"
			v-model="height"
		/>
	</shape-input-fields-wrapper>
</template>
